import Section from "../../common/Section/Section";
import "./industry.css"

export default function EquitrackForIndustry() {
 const industries = [
  { title: "Equipment", path: "Equipment", image: "fa-solid fa-toolbox", color: "#1B75BB" },
  { title: "Tools", path: "Tools", image: "ai-tool", color: "#50A60A" },
  { title: "Plant Hire", path: "PlantHire", image: "fa-solid fa-helmet-safety", color: "#CC0612" },
  { title: "Rope Access", path: "RopeAccess", image: "fa-solid fa-globe", color: "#6E0CB0" }
 ]

 return (
  <Section title="equi-track for your industry">
   <div className="rounded-border bg-secondary h4 py-4">
    <div className="row row-cols-2 row-cols-lg-4 py-lg-4 w-100 m-0 px-lg-4">
     {industries.map(({ title, path, image, color }, index) => {
      return (
       <div key={index} className="col">
        <div className="d-flex justify-content-start justify-content-md-center align-items-center py-4">
         <i className={`${ image } mx-2`} style={{ color }}></i>
         <a target="_self" href={`/Industries/${ path }`} className="industry-links">
          <span className={`text-center w-100`} style={{ color }}>{title}</span>
         </a>
        </div>
       </div>
      )
     })}</div>
   </div>
  </Section>
 )
}